module.exports = __webpack_public_path__ + "media/images/front/icon_earth_01-658a9e129f531733425094bf8607058c.svg";